<template>
  <div class="ui container moderation-page">
    <h1 class="ui header">
      Modération
    </h1>
    <p
      v-if="loading"
      class="moderation-status"
    >
      Chargement des signalements…
    </p>
    <p
      v-else-if="!features.length"
      class="moderation-status"
    >
      Aucun signalement en attente de modération.
    </p>
    <table
      v-else
      class="ui celled table"
    >
      <thead>
        <tr>
          <th>Signalement</th>
          <th>Projet</th>
          <th>Mis à jour</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="feature in features"
          :key="feature.feature_id"
        >
          <td>
            <router-link
              :to="{
                name: 'details-signalement',
                params: {
                  slug: feature.project_slug,
                  slug_type_signal: feature.feature_type_slug,
                  slug_signal: feature.feature_id,
                },
              }"
            >
              {{ feature.title }}
            </router-link>
          </td>
          <td>{{ feature.project_title }}</td>
          <td>{{ formatDate(feature.updated_on) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from '@/axios-client.js';

export default {
  name: 'Moderation',

  data() {
    return {
      loading: true,
      features: [],
    };
  },

  computed: {
    ...mapState([
      'configuration',
      'user',
    ]),
  },

  watch: {
    user() {
      this.loadQueue();
    },
  },

  mounted() {
    this.loadQueue();
  },

  methods: {
    formatDate(value) {
      if (!value) {
        return '';
      }
      return new Date(value).toLocaleString('fr-FR');
    },

    async loadQueue() {
      this.loading = true;
      if (!this.user) {
        this.features = [];
        this.loading = false;
        return;
      }
      const baseUrl = this.configuration.VUE_APP_DJANGO_API_BASE;
      try {
        const response = await axios.get(`${baseUrl}moderation-queue/`);
        this.features = response.data.features || [];
      } catch (error) {
        this.features = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.moderation-page {
  padding: 2rem 0 3rem;
}

.moderation-status {
  color: #4a5568;
}
</style>
